import type { ReactNode } from 'react';
import { Card } from '@ics-portal/guardian';
import type { Scalars } from '@gql/graphql';
import { getProjectPath, ProjectPath } from '@utils/getMenuContent';
import { useSummaryCards } from '@pages/project/summary/_utils/contexts/SummaryCardsContext';
import { SummaryCardContent } from './components/SummaryCardContent';
import s from './SummaryCards.module.scss';
import { SummaryCardTitle } from './components/SummaryCardTitle';

interface ComponentsCardProps {
    pid: Scalars['ID']['input'];
}

export default function ComponentsCard({
    pid,
}: ComponentsCardProps): ReactNode {
    const { data } = useSummaryCards();
    const components = data?.componentsCount;

    return (
        <Card
            title={
                <SummaryCardTitle
                    icon="shapes"
                    title="Components"
                    iconClassName={s.componentsIcon}
                />
            }
            cardClassName={s.card}
            foldable={false}
        >
            <SummaryCardContent
                footer={<h2 className="text-white">{components}</h2>}
                to={getProjectPath(ProjectPath.Components, pid)}
            />
        </Card>
    );
}
